import { type AmountUnit, formatValueByUnit } from '@/utils';
import type { FC } from 'react';
import { Flex, Text } from '..';

type Props = {
  count: number | null;
  amount: number | null;
  unit: AmountUnit;
  isDebugMode?: boolean;
  negativeCount?: number | null | undefined;
};

export const CountAmountCell: FC<Props> = ({
  amount,
  count,
  unit,
  negativeCount,
  isDebugMode,
}) => {
  return (
    <Flex justify="space-between">
      <Text text={`(${formatValueByUnit(count)})`} />
      <Text
        text={formatValueByUnit(amount, {
          operation: 'round',
          unit,
          isDebugMode,
          negativeCount,
        })}
      />
    </Flex>
  );
};
